// extracted by mini-css-extract-plugin
export var closeIcon = "MapModal-module--closeIcon--f9217";
export var container = "MapModal-module--container--90a7c";
export var modalContent = "MapModal-module--modalContent--6a796";
export var modalHeading = "MapModal-module--modalHeading--c3f9b";
export var modalInfo = "MapModal-module--modalInfo--7e048";
export var modalMap = "MapModal-module--modalMap--abe89";
export var modalSection = "MapModal-module--modalSection--50222";